import {Component, Input} from '@angular/core';

@Component({
  templateUrl: './park-rain-sensor-controls.html',
  selector: 'park-rain-sensor-controls'
})

export class ParkRainSensorControlsComponent {
  @Input() public rainSensors: any;
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public color: string;
  objectKeys = Object.keys;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/others/rain_sensor/park-rain-sensor-controls.component.ts